<template>
  <div>
    <chartjs-pie-card
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="card-title diligencePieChartTitle">
                Portfolio Composition
              </div>
              <div
                class="d-flex"
                style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
                v-tooltip.top-end="toolTipInfo"
              >
                <img src="static/img/graphInfo.svg" class />
              </div>
            </div>
          </div>
          <div>
            <el-select
              class="dashboard-dropdown-el-select select-primary"
              size="small"
              placeholder="Select Value Graph"
              v-model="category.selected"
              @change="categoryChange"
            >
              <el-option
                v-for="option in categoryDropdown"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import _ from "lodash";
import { ChartjsPieCard } from "src/components/index";
export default {
  name: "lp-gender-chart",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [ChartjsPieCard.name]: ChartjsPieCard,
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      category: {
        selected: "ceo",
        title: "Ceo",
      },
      textCenterLabel: [],
      ceoDataSets: [],
      ceoLabels: [],
      founderDataSets: [],
      founderLabels: [],
      founderTextCenterLabel: [],
      ceoTextCenterLabel: [],
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("charts", ["genderChartData"]),
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "By CEO", value: "ceo" };
      dropDownArray[1] = { label: "By Founders", value: "founder" };
      return dropDownArray;
    },
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset,
      };
      return data;
    },
    chartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: 60,
        plugins: {
          doughnutlabel: {
            labels: self.textCenterLabel,
          },
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 15,
          },
        },
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    toolTipInfo() {
      let self = this;
      let retval = "";
      if (self.category.selected == "ceo") {
        retval = `The donut chart breakdown is of male and female CEO’s as a percentage of investments across the fund. This data is collected from Crunchbase`;
      } else {
        retval = `The donut chart breakdown is of male and female Founders’s as a percentage of investments across the fund. This data is collected from Crunchbase`;
      }
      return retval;
    },
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // do initial calculate for chart data
      let ceoLabels = [];
      let ceoBackgroundColors = [];
      let ceoValues = [];
      let ceoValues_p = [];
      let ceoTotalLength = 0;
      let founderLabels = [];
      let founderBackgroundColors = [];
      let founderValues = [];
      let founderValues_p = [];
      let founderTotalLength = 0;
      self.founderTextCenterLabel = [];
      self.ceoTextCenterLabel = [];
      if (
        self.genderChartData &&
        self.genderChartData.ceo &&
        self.genderChartData.ceo.male
      ) {
        ceoTotalLength = self.genderChartData.ceo.female
          ? self.genderChartData.ceo.male + self.genderChartData.ceo.female
          : self.genderChartData.ceo.male;
        ceoLabels.push("Male");
        ceoValues.push(self.genderChartData.ceo.male);
        ceoValues_p.push(
          ((self.genderChartData.ceo.male / ceoTotalLength) * 100).toFixed(2)
        );
        //ceoBackgroundColors.push("#451EEF");
        ceoBackgroundColors.push("#6771dc");
        let ceoTextCenterLabel = `Male - ${(
          (self.genderChartData.ceo.male / ceoTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: ceoTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.ceoTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.ceo &&
        self.genderChartData.ceo.female
      ) {
        ceoTotalLength = self.genderChartData.ceo.male
          ? self.genderChartData.ceo.male + self.genderChartData.ceo.female
          : self.genderChartData.ceo.female;
        ceoLabels.push("Female");
        ceoValues.push(self.genderChartData.ceo.female);
        ceoValues_p.push(
          ((self.genderChartData.ceo.female / ceoTotalLength) * 100).toFixed(2)
        );
        // ceoBackgroundColors.push("#FF6969");
        ceoBackgroundColors.push("#c767dc");
        let ceoTextCenterLabel = `Female - ${(
          (self.genderChartData.ceo.female / ceoTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: ceoTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.ceoTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.founder &&
        self.genderChartData.founder.male
      ) {
        founderTotalLength = self.genderChartData.founder.female
          ? self.genderChartData.founder.male +
            self.genderChartData.founder.female
          : self.genderChartData.founder.male;
        founderLabels.push("Male");
        founderValues.push(self.genderChartData.founder.male);
        founderValues_p.push(
          (
            (self.genderChartData.founder.male / founderTotalLength) *
            100
          ).toFixed(2)
        );
        //founderBackgroundColors.push("#451EEF");
        founderBackgroundColors.push("#6771dc");
        let founderTextCenterLabel = `Male - ${(
          (self.genderChartData.founder.male / founderTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: founderTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.founderTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.founder &&
        self.genderChartData.founder.female
      ) {
        founderTotalLength = self.genderChartData.founder.male
          ? self.genderChartData.founder.male +
            self.genderChartData.founder.female
          : self.genderChartData.founder.female;
        founderLabels.push("Female");
        founderValues.push(self.genderChartData.founder.female);
        founderValues_p.push(
          (
            (self.genderChartData.founder.female / founderTotalLength) *
            100
          ).toFixed(2)
        );
        // founderBackgroundColors.push("#FF6969");
        founderBackgroundColors.push("#c767dc");
        let founderTextCenterLabel = `Female - ${(
          (self.genderChartData.founder.female / founderTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: founderTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.founderTextCenterLabel.push(obj);
      }
      self.ceoDataSets = [];
      self.ceoLabels = [];
      self.ceoLabels = ceoLabels;
      self.ceoDataSets.push({
        header_label: ceoLabels,
        data: ceoValues_p,
        data_value: ceoValues,
        backgroundColor: ceoBackgroundColors,
      });
      self.founderDataSets = [];
      self.founderLabels = [];
      self.founderLabels = founderLabels;
      self.founderDataSets.push({
        header_label: founderLabels,
        data: founderValues_p,
        data_value: founderValues,
        backgroundColor: founderBackgroundColors,
      });
      self.datasets = [];
      self.labels = [];
      if (this.category.selected == "ceo") {
        self.datasets = JSON.parse(JSON.stringify(self.ceoDataSets));
        self.labels = JSON.parse(JSON.stringify(self.ceoLabels));
        self.textCenterLabel = JSON.parse(
          JSON.stringify(self.ceoTextCenterLabel)
        );
      } else {
        self.datasets = JSON.parse(JSON.stringify(self.founderDataSets));
        self.labels = JSON.parse(JSON.stringify(self.founderLabels));
        self.textCenterLabel = JSON.parse(
          JSON.stringify(self.founderTextCenterLabel)
        );
      }
    },
    categoryChange() {
      const self = this;
      this.createPrimaryDataset();
    },
  },
  mounted() {
    this.categoryChange();
    let self = this;
    this.$store
      .dispatch("charts/getGenderChartData")
      .then((data) => {
        if (self.genderChartData) {
          self.createPrimaryDataset();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  },
  watch: {
    genderChartData: {
      handler(newData) {
        // updated portfolio, run update
        if (newData) this.createPrimaryDataset();
      },
    },
    $route(to, from) {
      this.category.selected = "ceo";
    },
  },
};
</script>